import React, { useEffect, useState } from 'react';

import protheusLogo from '../../assets/images/protheusLogo.png'
import fluigiLogo from '../../assets/images/fluigiLogo.png'
import { styleSheet } from '../../assets/styles/global';
import { useSkills } from '../../hooks/skills';

import {
  ProdutoContainer,
  ProdutoTitle,
  ProdutoIcon,
  ProdutoText,
} from './styles';
import { Accordion, Icon, Loader } from 'semantic-ui-react';

interface Props {
  title: string;
  children: React.ReactNode;
  codigo: string;
}

const AccordionProduct: React.FC<Props> = ({ children, title, codigo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { fetchModules, disFetchModules } = useSkills()

  async function handleGetModules(code: string) {
    setIsLoading(true)
    await fetchModules(code)
    setIsLoading(false)
  }

  return (
    <ProdutoContainer>
      <Accordion  fluid styled style={{ borderRadius: '8px' }}>
        <Accordion.Title
          active={isOpen}
          onClick={() => { 
            if(!isOpen) {
              handleGetModules(codigo);
            }
            setIsOpen(!isOpen) 
          }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: styleSheet.colorMain, borderRadius: '8px' }}
        >
          <ProdutoTitle>
            <ProdutoIcon src={title === 'Totvs Protheus' ? protheusLogo : fluigiLogo} />
            <ProdutoText>
              {title}
            </ProdutoText>
          </ProdutoTitle>
          <Icon name='dropdown' style={{ color: '#FFF', fontSize: '25px' }} />
        </Accordion.Title>

        <Accordion.Content active={isOpen}>
          {isLoading ? <Loader active inline='centered'>Carregando</Loader> : children}
        </Accordion.Content>
      </Accordion>
    </ProdutoContainer>
  );
}

export default AccordionProduct;